import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-folders.manage', {
        url: '/manage/:sharedFolderId',
		// params: { sharedFolder: {} },
		redirectTo: 'company.sharing-center.shared-folders.manage.edit',
        views: {
			'@company.sharing-center': 'companySharingCenterSharedFoldersManage'
		},
        resolve: {
            $breadcrumbs,
            sharedFolder,
            sharedFolderId,
            items
        }
    });
}

/** @ngInject */
function sharedFolderId($stateParams) {
    return $stateParams.sharedFolderId;
}

/** @ngInject */
function sharedFolder(sharedFolders, $stateParams) {
    return sharedFolders.find(sf => sf.id === $stateParams.sharedFolderId);
}

/** @ngInject */
function items(SharedFoldersResource, sharedFolderId, companyId, $filter) {
    return SharedFoldersResource.getSharedFolderItems(companyId, sharedFolderId)
    .then(items => $filter('orderBy')(items, 'createdOn', true))
    .then(items => {
        return items.map((item) => {
            item.type = itemType(item);
            const format = date => new Date(date).toString().slice(4, 24);
            item.createdOnDisplay = format(item.createdOn);
            if (item.corporateServiceAccount != null) {
                item.corporateServiceAccount = {...item.corporateServiceAccount, serviceDisplayName: serviceDisplayName(item.corporateServiceAccount)};
            }
            return item;
        })
    });
}

function $breadcrumbs(sharedFolder) {
    if(sharedFolder == null) {
        return;
    }
    const title = {
        // getter to allow dynamic updates
        get title() {
            return sharedFolder.name
        }
    };
    return [{stateName: 'company.sharing-center.shared-folders.manage'}, title];
}

function itemType(item) {
    let itemType = '';
    if (item.corporateNote != null) {
        itemType = 'SECURE NOTE';
    } else if (item.corporateServiceAccount.enabledTwoFa){
        itemType = 'AUTHENTICATOR';
    } else {
        itemType = 'PASSWORD MANAGER';
    }
    return itemType;
}

function serviceDisplayName(item) {
    let displayName = '';
    if (item.publicService.slug != 'other' || !item.customServiceName) {
        displayName = item.publicService.serviceName;
    } else if (item.publicService.slug == 'other'){
        displayName = item.customServiceName;
    }
    return displayName;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/manage-shared-folder.state.js